export const GET_NUMBER_OF_RECEIPTS_REQUEST = 'GET_NUMBER_OF_RECEIPTS_REQUEST'
export const GET_NUMBER_OF_RECEIPTS_SUCCESS = 'GET_NUMBER_OF_RECEIPTS_SUCCESS'
export const GET_NUMBER_OF_RECEIPTS_FAIL = 'GET_NUMBER_OF_RECEIPTS_FAIL'

export const GET_RECEIPT_METAINFO_REQUEST = 'GET_RECEIPT_METAINFO_REQUEST'
export const GET_RECEIPT_METAINFO_SUCCESS = 'GET_RECEIPT_METAINFO_SUCCESS'
export const GET_RECEIPT_METAINFO_FAIL = 'GET_RECEIPT_METAINFO_FAIL'

export const GET_RECEIPT_CATEGORY_REQUEST = 'GET_RECEIPT_CATEGORY_REQUEST'
export const GET_RECEIPT_CATEGORY_SUCCESS = 'GET_RECEIPT_CATEGORY_SUCCESS'
export const GET_RECEIPT_CATEGORY_FAIL = 'GET_RECEIPT_CATEGORY_FAIL'

export const GET_OWNER_UNIQUE_CUSTOMERS_REQUEST =
  'GET_OWNER_UNIQUE_CUSTOMERS_REQUEST'
export const GET_OWNER_UNIQUE_CUSTOMERS_SUCCESS =
  'GET_OWNER_UNIQUE_CUSTOMERS_SUCCESS'
export const GET_OWNER_UNIQUE_CUSTOMERS_FAIL = 'GET_OWNER_UNIQUE_CUSTOMERS_FAIL'

export const GET_OWNER_DASHBOARD_STATS_REQUEST =
  'GET_OWNER_DASHBOARD_STATS_REQUEST'
export const GET_OWNER_DASHBOARD_STATS_SUCCESS =
  'GET_OWNER_DASHBOARD_STATS_SUCCESS'
export const GET_OWNER_DASHBOARD_STATS_FAIL = 'GET_OWNER_DASHBOARD_STATS_FAIL'
